import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/apps/restatic/frontend/src/views/install/index.tsx");
